import React, { useEffect, useState } from "react";
import useFirebaseSearch from "../hooks/useFirebaseSearch";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import useSearchLocally from "../hooks/useSearchLocally";
import useTimer from "../hooks/useTimer";
import {
  checkFoundSomething,
  makeOption,
  objectToArray,
} from "../misc/helperfuncs";
import collectionStore from "../stores/collectionStore";
import lookupStore from "../stores/lookupStore";
import MainStore from "../stores/MainStore";
import CatSelector from "./CatSelector";
import IncludeCategories from "./IncludeCategories";

const LookUpInput = () => {
  const {
    selectedBoxType,
    activeSearch,
    setSelectedBoxType,
    setActiveSearch,
    foundStuff,
    setFoundStuff,
    mostField,
    mostRecentBoxes,
    mostSelectedBoxes,
  } = lookupStore();
  const [includeCategories, setIncludeCategories] = useState(false);
  const { setDisplayedOptions, setDisplayedBoxes, player } = MainStore();
  const handleBoxTypes = useHandleBoxTypes();
  const [enableSearch, setEnableSearch] = useState(false);
  const { addGeneralObjects } = collectionStore();
  const { getPluralType, getBoxType } = useHandleBoxTypes();

  function onSearchedOnline(results, type) {
    const merged = new Set(
      results.exact
        .concat(results.partially)
        .concat(results.categories)
        .concat(results.keywords)
    );

    if (
      results.exact.length > 0 ||
      results.partially.length > 0 ||
      results.categories.length > 0 ||
      results.keywords.length > 0
    ) {
      setFoundStuff(results);
      addGeneralObjects(merged, getPluralType);
    } else setFoundStuff(null);
  }

  function onSearchedLocally(results) {
    setFoundStuff({
      ...results,
      exact: [],
      partially: [],
      keywords: [],
      categories: [],
    });
    setEnableSearch(!checkFoundSomething(results));
  }

  useSearchLocally({
    input: activeSearch,
    what: "all",
    onSearched: onSearchedLocally,
  });

  useFirebaseSearch({
    searchInput: activeSearch,
    type: selectedBoxType,
    onSearched: onSearchedOnline,
    includeCategories: includeCategories,
    searching: enableSearch,
  });

  function onCreateClicked(boxType) {
    console.log("boxType - ", boxType);
  }

  function sendOptionsToDisplayedOptions() {
    const displayedOptions = [];
    if (selectedBoxType == "all") {
      //name, image, func, color
      objectToArray(player.boxTypes).forEach((kv) => {
        const option = makeOption(
          kv.value.names.singular,
          kv.value.icon,
          onCreateClicked,
          kv.value.colors.primary
        );
        displayedOptions.push(option);
      });
    } else {
      const boxType = player.boxTypes[selectedBoxType];
      const option = makeOption(
        boxType.names.plural,
        boxType.icon,
        onCreateClicked,
        boxType.colors.priamrgy
      );
      displayedOptions.push(option);
    }
    setDisplayedOptions(displayedOptions);
  }

  const mostObj = {
    recent: mostRecentBoxes,
    selected: mostSelectedBoxes,
    none: [],
  };

  useEffect(() => {
    if (activeSearch.length > 3) {
      if (!foundStuff) {
        sendOptionsToDisplayedOptions();
      } else setDisplayedOptions([]);
    } else {
      setDisplayedOptions([]);
      setFoundStuff(null);
      setDisplayedBoxes(mostObj[mostField]);
      setEnableSearch(false);
    }
  }, [foundStuff, activeSearch]);

  return (
    <div
      className="divRow"
      style={{
        width: "50%",
        position: "relative",
        justifyContent: "space-between",
      }}
    >
      {selectedBoxType != "all" && (
        <IncludeCategories
          includeCategories={includeCategories}
          setIncludeCategories={setIncludeCategories}
        />
      )}
      <input
        maxLength={40}
        value={activeSearch}
        onChange={(e) => {
          setActiveSearch(e.target.value.replace(/[^a-z\s]/gi, ""));
        }}
        style={{
          flex: 1,
          fontFamily: "Roboto-Bold",
          textAlign: "center",
          color: "gray",
          fontSize: "20px",
          padding: "2px",
        }}
        placeholder="Look something up"
      />
      <CatSelector
        selectedBoxType={selectedBoxType}
        setSelectedBoxType={setSelectedBoxType}
      />
    </div>
  );
};

export default LookUpInput;
